import { useSetAtom } from "jotai";
import { accessTokenAtom, tokenAnsweredAtom } from "store/tokenStore";
import { pushLocStringsAtom } from "store/pushLocStringsStore";

export const useWebviewMessage = () => {
    const setAccessToken = useSetAtom(accessTokenAtom);
    const setTokenAnswered = useSetAtom(tokenAnsweredAtom);
    const setPushLocStrings = useSetAtom(pushLocStringsAtom);

    return (type: string, data: any) => {
        switch (type) {
            case "SEND_TOKEN": {
                // 앱은 로그아웃 상태에서도 빈 값으로 보낸다 — 값 자체보다 '답이 왔다'는 사실이
                // 중요하다. undefined 가 그대로 저장돼 "undefined" 문자열이 되지 않게 막는다.
                const accessToken = typeof data?.accessToken === "string" ? data.accessToken : "";
                // 토큰 값 자체는 찍지 않는다 — 웹뷰 디버깅·개발자도구로 그대로 노출된다.
                console.log("token :: received", accessToken ? "ok" : "empty");
                sessionStorage.setItem("accessToken", accessToken);
                setAccessToken(accessToken);
                setTokenAnswered(true);
                break;
            }
            case "SEND_PUSH_LOC_STRINGS":
                setPushLocStrings(data ?? {});
                break;
            default:
                break;
        }
    };
};
